module.exports = __webpack_public_path__ + "static/jubeat-2970c5c61318849e1bd24bf79985e2f2.jpeg";